$(function(){
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $("body").on("click",".cancel-results-gameresult",function(){
        var c1=$(this).attr("data-t1");
        var c2=$(this).attr("data-t2");
        var $scope=$(this).parent().parent();
        var inputs=$scope.find("input");
        $(inputs[0]).val(_.isUndefined(c1)?"":c1).change();
        $(inputs[1]).val(_.isUndefined(c2)?"":c2).change();

    });

    $("body").on("click",".save-result-gameresults",function(){
        var $scope=$(this).parent().parent();
        var inputs=$scope.find("input");
        var v1=$(inputs[0]).val();
        var v2=$(inputs[1]).val();
        var id=$(this).attr("data-id");
        var but1=$scope.find(".cancel-results-gameresult");
        var but2=$scope.find(".save-result-gameresults");
        but1.attr("data-t1",v1);
        but1.attr("data-t2",v2);
        but1.attr("disabled","disabled");
        but2.attr("disabled","disabled");

        $.post("/gameboard/results/save/"+id,{t1:v1,t2:v2},function(response){
            $scope.find(".success-saved").fadeIn(function(){
                setTimeout(function(){
                    $scope.find(".success-saved").fadeOut();
                },5000);
            });
        });
    });

    $("body").on("keydown",".gameresults-table input",function(e){
        if((e.keyCode>=48 && e.keyCode<=58) || e.keyCode==8 || e.keyCode==46)
            return true;
        e.preventDefault();
        return false;
    });


    $("body").on("keyup change",".gameresults-table input",function(e){
        var $scope=$(this).parent().parent().parent();
        var inputs=$scope.find("input");
        var but1=$scope.find(".cancel-results-gameresult");
        var but2=$scope.find(".save-result-gameresults");

        var inp1=$(inputs[0]);
        var inp2=$(inputs[1]);
        var c1=but1.attr("data-t1");
        var c2=but1.attr("data-t2");

        if(inp1.val().length && inp2.val().length)
        {
            if(inp1.val()!=c1 || inp2.val()!=c2)
            {
                //check value same of store
                but2.prop("disabled","");
                but1.prop("disabled","");
            }else{
                but1.prop("disabled","disabled");
                but2.prop("disabled","disabled");
            }

        }else{
            but1.prop("disabled","disabled");
            but2.prop("disabled","disabled");
        }
    });

});